import React, { Component } from 'react'

class DurationInput extends Component {

    state = {
        valueInputNumber: '',
        valueInputNumber1: '',
        valueInputNumber2: '',
        time: {}
    }

    componentDidMount() {
        console.log('dataaaddd',this.props.data);
        if (this.props.data) {
            // let data = this.props.data
            let data = this.state.data
            if (Array.isArray(this.props.data)) {
                data = this.props.data
            }
            else {
                data = this.props.data.split(':')
            }
            this.setState({ data }, () => {
                this.setState({ valueInputNumber: data[0], valueInputNumber1: data[1], valueInputNumber2: data[2] })
            })

            console.log('DUrationInputdata', data)
        }
    }
componentDidUpdate(prevProps){
    if (this.props.data && JSON.stringify(prevProps.data)!= JSON.stringify(this.props.data) ) {
        let data = this.state.data
        if (Array.isArray(this.props.data)) {
            data = this.props.data
        }
        else {
            data = this.props.data.split(':')
        }
        this.setState({ data }, () => {
            this.setState({ valueInputNumber: data[0], valueInputNumber1: data[1], valueInputNumber2: data[2] })
        })

    } 
}
    render() {
        let information = this.props.header?.information
        return (
            <div>
                <div className="text-start" style={{ display: 'flex', zIndex: 5, maxWidth: 300, minWidth: 300 }}>
                    <div className={'search-drop-down '} style={{ paddingBottom: 10, paddingTop: 10, display: 'flex', flexDirection: 'column', width: '100%', }}>
                        <div className='flexc mx-3 '>
                            <input className={!information.disabled ? 'modern-input-inquiry' : 'modern-input-deactive'} disabled={information?.disabled} style={{ width: "40px ", cursor: !information.disabled ? 'text' : 'not-allowed' }} placeholder='00' type='text' name="number" readOnly={!information.disabled ? false : true} maxLength={2} value={this.state.valueInputNumber}
                                onChange={(e) => {
                                    const value = e.target.value;
                                    if (!information?.disabled) {
                                        // if (this.props.openTime) {
                                        if (/^\d{0,2}$/.test(value)) {
                                            this.setState({ valueInputNumber: value })
                                            let duration = this.props.data ?? []
                                            duration[0] = value
                                            this.props.changeValue(this.props.header.key, duration, this.props.extra)
                                        }
                                    }
                                }} />
                            <p className='px-2'>:</p>
                            <input className={!information.disabled ? 'modern-input-inquiry' : 'modern-input-deactive'} disabled={information?.disabled} style={{ width: "40px ", cursor: !information.disabled ? 'text' : 'not-allowed' }} placeholder='00' type='text' name="number" readOnly={!information.disabled ? false : true} maxLength={2} value={this.state.valueInputNumber1} onChange={(e) => {
                                const value = e.target.value;
                                if (!information?.disabled) {
                                    if (value < 60) {
                                        // if (this.props.openTime) {
                                        if (/^\d{0,2}$/.test(value)) {
                                            this.setState({ valueInputNumber1: value })
                                            let duration = this.props.data ?? []
                                            duration[1] = value
                                            this.props.changeValue(this.props.header.key, duration, this.props.extra)
                                        }
                                    }
                                }
                            }} />
                            <p className='px-2'>:</p>
                            <input className={!information.disabled ? 'modern-input-inquiry' : 'modern-input-deactive'} disabled={information?.disabled} style={{ width: "40px ", cursor: !information.disabled ? 'text' : 'not-allowed' }} placeholder='00' type='text' name="number" readOnly={!information.disabled ? false : true} maxLength={2} value={this.state.valueInputNumber2} onChange={(e) => {
                                const value = e.target.value;
                                if (!information?.disabled) {
                                    if (value < 60) {
                                        // if (this.props.openTime) {
                                        if (/^\d{0,2}$/.test(value)) {
                                            this.setState({ valueInputNumber2: value })
                                            let duration = this.props.data ?? []
                                            duration[2] = value
                                            this.props.changeValue(this.props.header.key, duration, this.props.extra)
                                        }
                                    }
                                }
                            }} />
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default DurationInput;